module.exports = __webpack_public_path__ + "fonts/AudiType-WideBold_4.03.c5e716f0.woff";